import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // ✅ Import Tailwind styles
import App from "./App.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
